//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PwrError from "../../common/misc/PwrError.vue";
import Logo from "../../common/svg/Logo";
import MemberPassword from "./profile/form/MemberPassword.vue";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import ErrorDisplay from "../../common/ErrorDisplay.vue";

export default {
  name: "PasswordResetConfirm",
  components: {
    Logo,
    PwrError,
    MemberPassword,
    ErrorDisplay,
  },
  props: ["defaultUsername"],
  data() {
    return {
      username: this.defaultUsername,
      code: "",
      newPassword: "",
      resetConfirmationSuccessful: false,
      loading: false,
      error: null,
      reenterPassword: "",
    };
  },
  validations: {
    username: {
      required,
    },
    code: {
      required,
    },
    newPassword: {
      required,
      minLength: minLength(8),
      capital: (value) => /[A-Z]+/.test(value),
      lower: (value) => /[a-z]+/.test(value),
      number: (value) => /[0-9]+/.test(value),
      symbol: (value) => /[#@!$%^&*()_|~`{}\[\]:";'<>?,.\/]+/.test(value),
    },
    reenterPassword: {
      required,
      sameAsNewPassword: sameAs("newPassword"),
    },
  },
  methods: {
    async passwordResetConfirm() {
      this.loading = true;
      this.error = null;
      try {
        await this.$store.dispatch("confirmPasswordReset", {
          email: this.username,
          code: this.code,
          password: this.newPassword,
        });
        this.resetConfirmationSuccessful = true;
        this.code = "";
        this.username = "";
        this.newPassword = "";
        this.reenterPassword = "";
        await this.showModal();
      } catch (error) {
        this.handleSignupError(error);
      } finally {
        this.loading = false;
      }
    },
    handleSignupError(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.loading = false;
    },
    async showModal() {
      await this.confirmation({
        message:
          "Password reset confirmed. You may now login with your new password.",
        messageSize: "h5 has-text-gray",
        confirmType: "success",
        confirmText: "OK",
        showCancel: false,
      });
      this.modalHidden();
    },
    modalHidden() {
      if (this.resetConfirmationSuccessful) {
        this.$router.replace({ name: "login" });
      }
    },
  },
  computed: {
    reenter_state() {
      if (this.$v.$dirty) {
        return this.$v.reenterPassword.sameAsNewPassword;
      }
      return null;
    },
  },
};
